import styled from 'styled-components';
import { motion } from 'framer-motion';

export const StyledTimetable = styled(motion.div)`
    width: 100%;
`;
